/*
 * The customer mapping tab for QBO integration customer sync mappings.
 */
import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
// import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';

import withStyles from '@mui/styles/withStyles';
import { Table, TableHead, TableCell, TableBody, TableRow, TableSortLabel, Typography } from '@mui/material';
import { Button, Grid, Input, Link, NativeSelect, Paper } from '@mui/material';
import { TablePagination } from '@mui/material';

import TabPageTitle from '../ui/TabPageTitle';
import ServerError from '../ui/ServerError';
import LoadingSpinner from '../ui/LoadingSpinner';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();

const QBOCustomersQuery = graphql`
query QBOCustomersQuery($resellerAccountId: UUID!, $accountName: String!, $accountNumber: String!, $activeOnly: Int,  $floatProblemOnly: Int, $outstandingSOOnly: Int, $orderBy: Int, $direction: Int, $first: Int, $offset: Int) {
  accountsearchforcustomer4(reselleraccountid: $resellerAccountId, accountname: $accountName, accountnumber: $accountNumber, activeonly: $activeOnly, floatproblemonly: $floatProblemOnly, outstandingsoonly: $outstandingSOOnly, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {
    totalCount
    nodes {
      accountId
      accountName
      accountNum
      contactLastName
      contactFirstName
      contactEmail
      contactPhone
      accountStatus
      customerStatus
      floatProblem
      declineCount
      lastDeclineReason
      lastDeclineChargeAmount
      soStatus
      connectedEntities {
        accountIntegrationId
        appName
        appLogo
        appLogoWide
        entity
        entityId
      }
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  },
  radio: {
    marginTop: 16
  },
  formControl: {
    marginTop: '24',
  },
  nselect: {
    minWidth: 150
  }
});

class QBOCustomers extends Component {
  state = {
    forceFetch: 0,
    c_list: [],
    customerMaps: [],  // Changed customer mappings
    customerName: '',
    customerNum: '',
    activeOnly: 1,
    floatProblemOnly: 0,
    outstandingSOOnly: 0,
    orderBy: 0,
    orderDir: 1,
    page: 0,
    rowsPerPage: 25,
    mountComplete: 0
  };

  propsCustomers = []; // Class variable so that saveDisabled can work outside of QueryRenderer

  componentDidMount() {
    const { callPartnerApi, logError } = this.props.auth;

    let payload = {
      operation: "QBOGetCustomers"
    };

    // Make value available
    let c_list = [];

    callPartnerApi('appbind/generic',
                    'POST',
                    payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      if (response != null && response.body != null && response.body.body != null && response.body.body.QueryResponse != null) {
        if (response.body.body.QueryResponse.Customer != null) {
          // There are customers
          c_list = response.body.body.QueryResponse.Customer;
        }
        this.setState({c_list: c_list, mountComplete: 1});
      }
    })
    .catch(error => {
      logError('Exception in IntegrationSetupQBO.js: ' + error);
      this.setState({mountComplete: 1});
    });
  }

  goTo(route) {
    var searchToSave = {customerName: this.state.customerName, customerNum: this.state.customerNum, activeOnly: this.state.activeOnly, floatProblemOnly: this.state.floatProblemOnly, orderBy: this.state.orderBy}
    var searchTerms = JSON.stringify(searchToSave);
    localStorage.setItem('customersSterms', searchTerms);
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  toggleOrder = (ob) => {
    let newDir = 0;
    if (ob === this.state.orderBy) {
      if (this.state.orderDir === 0) {
        newDir = 1;
      }
    } else {
      newDir = 1;
    }

    this.setOrderBy(ob, newDir);
  } 

  setOrderBy = (ob, dir) => {
    let thedir = dir;
    if (dir === 'asc') {
      thedir = 1;
    } else if (dir === 'desc') {
      thedir = 0;
    }
    if (thedir !== 0 && thedir !== 1) {
      thedir = 1;
    }
    this.setState({orderBy: ob, orderDir: thedir, page: 0});
  }

  updateCustomerMap(theCustomer, wantedEntityId) {
    theCustomer.wantedEntityId = wantedEntityId;

    if (wantedEntityId === '') {
      // This should only happend when the user stays on the 'Do not map' option.
      theCustomer.entityDescription = '';
    } else if (wantedEntityId === 'NEW') { 
      theCustomer.entityDescription = 'New customer';
    } else if (wantedEntityId === 'DROP') {
      // Lookup the name of the existing mapped customer from the qbo list
      /*
      for (let i = 0; i < this.state.c_list.length; i++) {
        if (this.state.c_list[i].Id === theCustomer.entityId) {
          theCustomer.entityDescription = this.state.c_list[i].DisplayName;
          break;
        }
      }
      */
    } else {
      // Lookup the name from the QBO list
      for (let i = 0; i < this.state.c_list.length; i++) {
        if (this.state.c_list[i].Id === wantedEntityId) {
          theCustomer.entityDescription = this.state.c_list[i].DisplayName;
          break;
        }
      }
    }

    // Is this in state already?
    let customerMaps = this.state.customerMaps;
    let found = false;
    for (let i=0; i<customerMaps.length; i++) {
      if (customerMaps[i].accountId === theCustomer.accountId) {
        customerMaps[i].wantedEntityId = theCustomer.wantedEntityId;
        customerMaps[i].entityDescription = theCustomer.entityDescription;
        found = true;
        break;
      }
    }

    if (!found) {
      customerMaps.push(theCustomer);
    }
    this.setState({customerMaps: customerMaps});
  }

  isSaveDisabled() {
    if (this.state.customerMaps.length > 0) {
      // Compare each state entity to the original in the list
      for (let i=0; i<this.state.customerMaps.length; i++) {
        let aMap = this.state.customerMaps[i];

        let foundChange = false;
        if (this.propsCustomers != null && this.propsCustomers.length > 0) {
          for (let j=0; j<this.propsCustomers.length; j++) {
            let aCust = this.propsCustomers[j];
            if (aMap.accountId === aCust.accountId) {
              if (aMap.wantedEntityId !== aCust.entityId) {
                foundChange = true;
              }
              break;
            }
          }
        }
        
        if (foundChange) {
          return false;
        }
      }

    }
    return true;
  }

  clearChanges() {
    this.setState({customerMaps: []});
  }

  saveSettings() {
    const { callPartnerApi, logError } = this.props.auth;

    // Build the payload
    let theLinkAccounts = [];

    for (let i=0; i<this.state.customerMaps.length; i++) {
      let aMap = this.state.customerMaps[i];

      // Mode is "Link" if creating a mapping, or creating a new entity in QBO.
      let theMode = 'Link';

      let theEntityId = aMap.wantedEntityId;
      if (aMap.wantedEntityId === 'NEW') {
        // Creating a new entity in QBO, so the entity id is null.
        theEntityId = null;
      } else if (aMap.wantedEntityId === 'DROP') {
        // Removing an existing link, so the mode is "Unlink".
        theMode = 'Unlink';
      } else if (aMap.wantedEntityId === '' || aMap.wantedEntityId == null) {
        // This should only happen if we stay on "do not map".  In this case, we don't need to do anything.
        continue;
      }

      let aLinkEntry = {
        appName: 'QuickBooks',
        accountIdToLink: aMap.accountId,
        connectedAppEntityId: theEntityId,
        mode: theMode
      }

      theLinkAccounts.push(aLinkEntry);
    }

    if (theLinkAccounts.length === 0) {
      // Nothing to do, so no need to call.  This shouldn't happen.  Anyway, treat as 
      // an unset.
      this.setState({customerMaps: []});
      return;
    }

    // If parms are non-null, we have mappings.
    let payload = {
      operation: "linkCustomerAccounts",
      params: {
        linkAccounts: theLinkAccounts
      }
    };

    let c_list = [];
    let forceFetch = this.state.forceFetch;
    forceFetch++;

    Promise.resolve()
    .then(() => { 
      return callPartnerApi('appbind/generic',
                            'POST',
                            payload);
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      // Reload from QBO.
      let lookupPayload = {
        operation: "QBOGetCustomers"
      };
      return callPartnerApi('appbind/generic',
                            'POST',
                            lookupPayload);
    })
    .then(resp => {
      return resp.json();
    })
    .then(response => {
      if (response != null && response.body != null && response.body.body != null && response.body.body.QueryResponse != null) {
        c_list = response.body.body.QueryResponse.Customer;
        // console.log('c_list: ' + JSON.stringify(c_list));
        this.setState({c_list: c_list, forceFetch: forceFetch, customerMaps: []});
      }
    })
    .catch(error => {
      logError('Exception in IntegrationSetupQBO.js: ' + error);
      this.setState({forceFetch: forceFetch, customerMaps: []});
    });
  }

  render() {
    const { logError } = this.props.auth;
    const classes = this.props.classes;

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;
  
    let totalCount = 0;

    let accountId = abEnvironment.getUserAttribute('a_id');

    if (this.state.mountComplete === 0) {
      return (
        <LoadingSpinner />
      );
    }

    let theDir = 'asc';
    if (this.state.orderDir === 0) {
      theDir = 'desc';
    }

    return (
      <Grid container spacing={1} direction="row" justifyContent="flex-start">
        <Grid item xs={12}>
          <TabPageTitle title="Customer mappings" subtitle="Customers in AppBind can be mapped to customers in QBO."/>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
            <Grid item>
              <Grid container spacing={1} direction="row" justifyContent="flex-start">
                <Grid item>
                  <SearchField
                    id="customer-name-search"
                    label="Search by customer name"
                    value={this.state.customerName}
                    onChange={this.handleChange('customerName')}
                  />
                </Grid>
                <Grid item>
                  <SearchField
                    id="customer-num-search"
                    label="Search by customer identifier"
                    value={this.state.customerNum}
                    onChange={this.handleChange('customerNum')}
                  />
                </Grid>        
              </Grid>
            </Grid>
            <Grid item>
              <Grid container spacing={1} direction="row" justifyContent="flex-start">
                <Grid item>
                  <Button color="primary" 
                          variant="outlined" 
                          disabled={this.isSaveDisabled()} 
                          onClick={()=> { this.clearChanges() }}>
                    Undo unsaved changes
                  </Button>
                </Grid>
                <Grid item>
                  <Button color="primary" 
                          variant="contained" 
                          disabled={this.isSaveDisabled()} 
                          onClick={()=> { this.saveSettings() }}>
                    Save mappings
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={QBOCustomersQuery}
            variables={{resellerAccountId: accountId,
                        accountName: this.state.customerName,
                        accountNumber: this.state.customerNum,
                        activeOnly: this.state.activeOnly,
                        floatProblemOnly: this.state.floatProblemOnly,
                        outstandingSOOnly: this.state.outstandingSOOnly,
                        orderBy: this.state.orderBy,
                        direction: this.state.orderDir,
                        first: first,
                        offset: offset,
                        forceFetch: this.state.forceFetch}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                totalCount = props.accountsearchforcustomer4.totalCount;

                let propsCustomers = props.accountsearchforcustomer4.nodes;

                // Prepass to present customer data taking state into account
                this.propsCustomers = [];
                let displayCustomers = [];
                for (let i=0; i<propsCustomers.length; i++) {

                  // Adjust the shape
                  let theAccountIntegrationId = null;
                  let theEntityId = '';
                  if (propsCustomers[i].connectedEntities != null && propsCustomers[i].connectedEntities.length > 0) {
                    // Need to get the QBO id
                    for (let j=0; j<propsCustomers[i].connectedEntities.length; j++) {
                      if (propsCustomers[i].connectedEntities[j].appName === 'QuickBooks') {
                        theAccountIntegrationId = propsCustomers[i].connectedEntities[j].accountIntegrationId;
                        theEntityId = propsCustomers[i].connectedEntities[j].entityId;
                      }
                    }
                  }

                  let theCustomer = {
                    accountId:            propsCustomers[i].accountId,
                    accountName:          propsCustomers[i].accountName,
                    accountNum:           propsCustomers[i].accountNum,
                    contactFirstName:     propsCustomers[i].contactFirstName,
                    contactLastName:      propsCustomers[i].contactLastName,
                    contactEmail:         propsCustomers[i].contactEmail,
                    accountIntegrationId: theAccountIntegrationId,
                    entityId:             theEntityId,
                    wantedEntityId:       theEntityId
                  };

                  this.propsCustomers.push(theCustomer);

                  if (this.state.customerMaps.length > 0) {
                    for (let j=0; j<this.state.customerMaps.length; j++) {
                      let aMap = this.state.customerMaps[j];
                      if (aMap.accountId === theCustomer.accountId) {
                        theCustomer = aMap;
                        break;
                      }
                    }
                  }

                  displayCustomers.push(theCustomer);
                }

                // Adjust qbo customer list
                let qboCustomers = [];
                for (let i=0; i< this.state.c_list.length; i++) {
                  let qCust = this.state.c_list[i];

                  for (let j=0; j<displayCustomers.length; j++) {
                    let dc = displayCustomers[j];
                    if (dc.entityId != null && dc.entityId === qCust.Id) {
                      qCust.accountId = dc.accountId;
                      break;
                    }
                  }
                  qboCustomers.push(qCust);
                }

                let rowCount = 0;
                return ( 
                  <div className={classes.paper}>
                    <Paper >
                      <Table>
                        <TableHead style={AppBindStyles.tableHead}>
                          <TableRow style={AppBindStyles.tableHeadRow}>
                            <TableCell>
                              <TableSortLabel
                                active={this.state.orderBy === 0}
                                direction={theDir}
                                onClick={() => this.toggleOrder(0) }>
                                Account name
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>
                              <TableSortLabel
                                active={this.state.orderBy === 1}
                                direction={theDir}
                                onClick={() => this.toggleOrder(1) }>
                                Internal identifier
                              </TableSortLabel>
                            </TableCell>
                            <TableCell>Contact</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>QBO Customer</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayCustomers.map(theCustomer => {
                            rowCount++;
                            let cId = "customer_" + rowCount;

                            let aUrl = "customer?accountId=" + theCustomer.accountId;

                            let qboCustomerOptions = [];
                            let createNewMapping = null;
                            let removeExistingMapping = null;
                            let doNotMap = null;
                            if (theCustomer.entityId === '') {
                              createNewMapping = 'Create new customer in QBO';
                              doNotMap = 'Not mapped';
                              // Not currently mapped
                              for (let i=0; i<qboCustomers.length; i++) {
                                let qCust = qboCustomers[i];
                                qCust.optionText = 'Map to ' + qCust.DisplayName;
                                qboCustomerOptions.push(qCust);
                              }
                            } else {
                              // Currently mapped
                              for (let i=0; i<qboCustomers.length; i++) {
                                // Currently mapped - so just show that existing map.
                                let qCust = qboCustomers[i];
                                if (qCust.Id === theCustomer.entityId) {
                                  qCust.optionText = qCust.DisplayName;
                                  qboCustomerOptions.push(qCust);
                                  removeExistingMapping = 'Remove mapping to ' + qCust.DisplayName;
                                  break;
                                }
                              }
                            }

                            return (
                              <TableRow key={theCustomer.accountId}>
                                <TableCell>
                                  <Link component="button" 
                                        variant="body2"
                                        className={classes.custlink}
                                        onClick={this.goTo.bind(this, aUrl)}>
                                    {theCustomer.accountName}
                                  </Link>
                                </TableCell>
                                <TableCell align="left">{theCustomer.accountNum}</TableCell>
                                <TableCell align="left">{theCustomer.contactFirstName}&nbsp;{theCustomer.contactLastName}</TableCell>
                                <TableCell align="left">{theCustomer.contactEmail}</TableCell>
                                <TableCell>
                                  <NativeSelect
                                    value={theCustomer.wantedEntityId}
                                    input={<Input name={cId} id={cId} />}
                                      onChange={(e) => this.updateCustomerMap(theCustomer, e.target.value) }
                                    >
                                    {qboCustomerOptions.map(c => {
                                      if (c.accountId == null || c.accountId === theCustomer.accountId) {
                                      return(<option key={c.Id} value={c.Id}>{c.optionText}</option>);
                                      } else {
                                        return null;
                                      }
                                    })}
                                    {createNewMapping != null &&
                                    <option key="NEW" value="NEW">{createNewMapping}</option>}
                                    {doNotMap != null &&
                                    <option key="" value="">{doNotMap}</option>}
                                    {removeExistingMapping != null &&
                                    <option key="DROP" value="DROP">{removeExistingMapping}</option>}
                                  </NativeSelect>                                
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Paper>
                    <div style={AppBindStyles.paginationTableFooter}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styleSheet)(QBOCustomers);

